<template lang="pug">
div
  slot(name="activator" :toggle="toggle")
    v-btn(small color='primary' 
      @click="toggle" 
      :disabled="disabled"
      outlined
    ) change course
  v-dialog(v-model="showing" scrollable max-width=400)
    courseChooseProvider(:item="formData" @input:course="updateCourse")
      template(v-slot:default="courseChoose")
        v-card
          v-card-title Change Course
          v-card-text
            filter-autocomplete(
              :value="formData.course.city" 
              @input="courseChoose.loadCoursesDatesByLocation"
              :getItems="getCourseLocation"
              label="Course Location" 
              item-value="ID" 
              item-text="name"
              :error="formErrors.hasError('courseLocation')"
              :error-messages="formErrors.fields.courseLocation"
            )
            v-autocomplete(
              :value="formData.course.ID" 
              @input="setCourseHandler($event, courseChoose.courses)"
              label="Course"
              :loading="courseChoose.loading" 
              :disabled="!courseChoose.courses.length"
              :items="courseChoose.courses" 
              item-text="dateAndName"
              item-value="ID"
              return-object
              :error="formErrors.hasError('courseDate')"
              :error-messages="formErrors.fields.courseDate"
            )
          v-card-actions
            v-spacer
            v-btn(color="error" text @click="toggle") Close
            v-btn(color="success" text @click="submit") Apply
</template>
<script>
import errorsMixin from '@/mixins/errors.mixin'
import FormErrors from "@/util/form-errors"
import { mapActions } from 'vuex'
import CourseModel from '../../../models/courseModel'

export default {
  mixins: [errorsMixin],
  props: {
    disabled: Boolean,
    activeItems: Array
  },
  data: () => ({
    formData: {
      course: new CourseModel(),
    },
    showing: false,
    formErrors: new FormErrors(),
    apiAttrs: {
      course_id: 'courseDate',
    },
  }),

  inject: ['svc'],

  methods: { 
    ...mapActions({
      getCourseLocation: 'crmCourseCities/list',
    }),
    toggle() {
      this.showing = !this.showing
    },

    submit() {
      if(!this.validate(this.formErrors)) {
        this.$notify({text: 'Invalid fields', type: 'error'})
        return
      }
      this.send()
    },

    validate(validator) {
      validator.resetFields()
      this.validateCourse(this.formData.course, validator)
      return validator.isValid()
    },

    validateCourse(course, validator) {
      if(!course.ID) {
        validator.invalidField('courseDate', 'field required')
      }
      if(!course.city) {
        validator.invalidField('courseLocation', 'field required')
      }
    },

    async send(payload) {
      try {
        let ids = this.activeItems.map(item => item.ID)
        let res = await this.svc().changeCourseBulk(ids, this.formData)
        this.$notify({text: 'Candidates course has been changed', type: 'success'})
        this.toggle()
        this.$emit('send', res)
      } catch (error) {
        console.log(error)
        this.processErrorWithForm(error, {
          redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE,
          formErrors: this.formErrors, 
          apiAttributes: this.apiAttrs
        });
      }
    },

    reset() {
      this.formData = {
        course: new CourseModel(),
      }
    },

    updateCourse(course) {
      this.formData.course = course
    },

    setCourseHandler(course, courses) {
      this.formData.course = course
    },
  },

  watch: {
    showing(isShowing) {
      if(!isShowing) {
        this.reset()
        return
      }
    }
  },

  components: {
    filterAutocomplete: () => import('@/components/global/FilterAutocomplete.vue'),
    CourseChooseProvider: () => import('./reservation/CandidateCourseChooseProvider.vue'),
  }
}
</script>
